import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/saved-empty.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-column align-items-center h-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "my-5"
}, null, -1)
const _hoisted_3 = { class: "text-4xl mb-3 text-center line-height-1" }
const _hoisted_4 = { class: "mb-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsList = _resolveComponent("EventsList")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.events.current_page > 0 && _ctx.events.total === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("events.subscribed_note")), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("events.subscribed_note2")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EventsList, {
      events: _ctx.events.data,
      grouped: "",
      onSave: _cache[0] || (_cache[0] = (event) => _ctx.updateSavedValue(event, true)),
      onUnsave: _cache[1] || (_cache[1] = (event) => _ctx.updateSavedValue(event, false))
    }, null, 8, ["events"]),
    (_ctx.events.total > 0)
      ? (_openBlock(), _createBlock(_component_Paginator, {
          key: 1,
          first: _ctx.events.from,
          "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.events.from) = $event)),
          rows: _ctx.events.per_page,
          totalRecords: _ctx.events.total,
          class: "py-6",
          onPage: _cache[3] || (_cache[3] = (e) => _ctx.updatePage(e.page))
        }, null, 8, ["first", "rows", "totalRecords"]))
      : _createCommentVNode("", true)
  ], 64))
}